// Pastille rouge de non-lus posee sur une tuile ou une icone de menu.
// className pilote uniquement le positionnement (absolute deja inclus).
export default function ModuleBadge({ count, className = '-top-2 -right-2' }) {
  if (!count || count <= 0) return null;
  return (
    <span
      className={`absolute min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1 shadow-md z-10 pointer-events-none ${className}`}
      data-testid="module-badge"
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
